module.exports = __webpack_public_path__ + "img/COMFORT.1bb53ba1.jpg";